import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TripRequestConfirmationView from './trip-request-confirmation-view';

const TripRequestConfirmationContainer = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const tripRequestId = params.get('tripRequestId');

  const handleViewClick = () => {
    if (tripRequestId) {
      navigate(`/trip-requests/${tripRequestId}`);
    }
  };

  return (
    <TripRequestConfirmationView
      handleViewClick={handleViewClick}
      isViewButtonDisabled={!tripRequestId}
    />
  );
};

export default TripRequestConfirmationContainer;
